import React from 'react';
import BestAutoTechAward from '../../../images/BestAutoTechAward.png';
import BestBuyAwards from '../../../images/BestBuyAwards.png';
import BestResaleValueAwards from '../../../images/BestResaleValueAwards.png';
import CostToOwnAwards from '../../../images/CostToOwnAwards.png';

//The awardCode to award src mapping is defined in the Python file parser.py that converts the awards.csv to awards.json

type Props = {
  awardCode: number;
}

const AwardImage: React.FC<Props> = ({ awardCode, }: Props,) => {
  switch (awardCode) {
    case 1:
      return (
        <img src={CostToOwnAwards} alt="CostToOwnAwards" style={{ width: '180px', }} />
      );
    case 2:
      return (
        <img src={BestAutoTechAward} alt="BestAutoTechAward" style={{ width: '180px', }} />
      );
    case 3:
      return (
        <img src={BestBuyAwards} alt="BestBuyAwards" style={{ width: '140px', }} />
      );
    case 4:
      return (
        <img src={BestResaleValueAwards} alt="BestResaleValueAwards" style={{ width: '180px', }} />
      );
    default:
      return <div />;
  }
};

export default AwardImage;
